// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M4.313 8.017a.994.994 0 0 0-.168.061c-.042.022-.96.92-2.04 1.999C.651 11.526.123 12.067.076 12.156c-.056.104-.064.149-.065.336 0 .175.01.236.053.324.075.152 3.942 4.018 4.105 4.104.097.051.146.06.33.06.25 0 .362-.044.533-.21a.67.67 0 0 0 .208-.522c0-.325.045-.27-1.39-1.705L2.568 13.26l10.446-.012 10.446-.012.12-.064c.189-.1.396-.355.396-.487 0-.02.01-.037.024-.037s.024-.072.024-.17c0-.093-.01-.163-.02-.156-.012.007-.033-.029-.048-.08-.068-.224-.316-.433-.57-.48-.097-.018-3.244-.026-10.472-.026H2.581l1.274-1.278C4.858 9.452 5.141 9.154 5.186 9.06a.86.86 0 0 0 .005-.617.904.904 0 0 0-.38-.382.969.969 0 0 0-.498-.044M.008 12.504c0 .099.004.14.01.09.005-.05.005-.13 0-.18-.006-.05-.01-.009-.01.09"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const KeyboardArrowLeftIcon = Icon;
export default KeyboardArrowLeftIcon;
